import React from 'react';
import { Home, Search, ShoppingCart, Info } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '../../hooks/useCart';
export function BottomNav() {
  const location = useLocation();
  const {
    totalItems
  } = useCart();
  const navItems = [{
    path: '/',
    label: 'Home',
    icon: Home
  }, {
    path: '/search',
    label: 'Search',
    icon: Search
  }, {
    path: '/cart',
    label: 'Cart',
    icon: ShoppingCart,
    badge: totalItems
  }, {
    path: '/wic-ebt-guide',
    label: 'Guide',
    icon: Info
  }];
  return <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 pb-safe pt-2 px-4 h-[72px] z-50 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] md:hidden" data-id="element-14">
      <div className="flex justify-around items-center h-full pb-2" data-id="element-15">
        {navItems.map(item => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        return <Link key={item.path} to={item.path} className="relative flex flex-col items-center justify-center w-16 h-full" data-id="element-16">
              <div className="relative p-1.5" data-id="element-17">
                {isActive && <motion.div layoutId="nav-indicator" className="absolute inset-0 bg-[#D97757]/10 rounded-xl" transition={{
              type: 'spring',
              bounce: 0.2,
              duration: 0.6
            }} data-id="element-18" />}
                <Icon className={`w-6 h-6 transition-colors duration-200 ${isActive ? 'text-[#D97757]' : 'text-gray-500'}`} strokeWidth={isActive ? 2.5 : 2} data-id="element-19" />
                <AnimatePresence data-id="element-20">
                  {item.badge ? <motion.span initial={{
                scale: 0
              }} animate={{
                scale: 1
              }} exit={{
                scale: 0
              }} key={item.badge} className="absolute -top-1 -right-1 bg-[#2D5F3F] text-white text-[10px] font-bold h-5 w-5 flex items-center justify-center rounded-full border-2 border-white" data-id="element-21">
                      {item.badge}
                    </motion.span> : null}
                </AnimatePresence>
              </div>
              <span className={`text-[10px] font-medium mt-1 transition-colors duration-200 ${isActive ? 'text-[#D97757]' : 'text-gray-500'}`} data-id="element-22">
                {item.label}
              </span>
            </Link>;
      })}
      </div>
    </nav>;
}